import { Button } from "@mui/material"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { deleteMyConversation } from "../../controllers/conversation/conversation"
import { deleteSinglePost } from "../../controllers/posts/posts"
import { useNavigate } from "react-router"

export const DeleteConversation = ({token, conversationId, statusIds = []}) => {
    let navigate = useNavigate()
    const queryClient = useQueryClient()
    const mutation = useMutation({
        mutationFn: async () => {
            // Delete every status the current user authored, then remove our
            // local conversation record (the sidecar's own bare-details doc).
            await Promise.all(statusIds.map(id => deleteSinglePost({id, token})))
            await deleteMyConversation({token, id: conversationId})
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['getMyConversations'] })
            navigate("/messages")
        },
    })

    return (
        <Button onClick={() => mutation.mutate()} disabled={mutation.isPending} variant='contained' color='error'>
            {mutation.isPending ? 'Deleting...' : 'Delete'}
        </Button>
    )
}
